const apiBaseURL = 'https://cv.truc-bidule.fr'; //

export default apiBaseURL;
